import React, { useState, useEffect, useCallback, useRef } from "react";
import Layout from "../Component/Layout";
import Inputbox from "../Component/Inputbox";
import {
  BiPlus,
  BiMinus,
  BiTrash,
  BiChevronDown,
  BiSolidCloudUpload,
} from "react-icons/bi";
import Button from "../Component/Button";
import { Link, useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import REACT_APP_API_URL from "../utils/constant";
import { showToast } from "../helper/Toster";
import Select from "react-select";
import Instagram from "../assets/Image/instagram.png";
import Youtube from "../assets/Image/youtube.png";
import Tiktok from "../assets/Image/tik-tok.png";
import Facebook from "../assets/Image/facebook.png";
import Twitter from "../assets/Image/twitter.png";
import Modal from "react-bootstrap/Modal";
import { useDropzone } from "react-dropzone";

function MyVerticallyCenteredModal({ show, onHide, onAddClub }) {
  const [clubName, setClubName] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (clubName.trim() !== "") {
      onAddClub(clubName); // Use the passed prop
      setClubName("");
      onHide(); // Close the modal after adding the club
    }
  };

  return (
    <Modal show={show} onHide={onHide} size="md" centered>
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          <h5 className="m-0">Add Club</h5>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={handleSubmit}>
          <div className="">
            <label htmlFor="mainClub" className="form-label fs-6">
              Main Club
            </label>
            <input
              type="text"
              placeholder="Enter main club"
              className="form-control"
              value={clubName}
              onChange={(e) => setClubName(e.target.value)}
              required
            />
          </div>
          <Button type="submit" className="px-5 mt-4">
            Add
          </Button>
        </form>
      </Modal.Body>
    </Modal>
  );
}

function AddClubModal({ show, onHide, onAddClub }) {
  const [clubName, setClubName] = useState("");
  const [clubUrl, setClubUrl] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (clubName.trim() !== "") {
      onAddClub({
        name: clubName,
        url: clubUrl.trim(),
        subClubs: [],
      });
      setClubName("");
      setClubUrl("");
      onHide();
    }
  };

  return (
    <Modal show={show} onHide={onHide} size="md" centered>
      <Modal.Header closeButton>
        <Modal.Title>Add Club</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label>Club Name</label>
            <input
              type="text"
              className="form-control"
              value={clubName}
              onChange={(e) => setClubName(e.target.value)}
              required
            />
          </div>
          <div className="mb-3">
            <label>Club URL (optional)</label>
            <input
              type="text"
              className="form-control"
              value={clubUrl}
              onChange={(e) => setClubUrl(e.target.value)}
            />
          </div>
          <Button type="submit">Add</Button>
        </form>
      </Modal.Body>
    </Modal>
  );
}

function AddSubClubModal({ show, onHide, onAddSubClub, mainClubIndex }) {
  const [subClubName, setSubClubName] = useState("");
  const [subClubUrl, setSubClubUrl] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (subClubName.trim() !== "") {
      onAddSubClub(mainClubIndex, {
        description: subClubName,
        url: subClubUrl.trim(),
      });
      setSubClubName("");
      setSubClubUrl("");
      onHide();
    }
  };

  return (
    <Modal show={show} onHide={onHide} size="md" centered>
      <Modal.Header closeButton>
        <Modal.Title>Add Subclub</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label>Subclub Description</label>
            <input
              type="text"
              className="form-control"
              value={subClubName}
              onChange={(e) => setSubClubName(e.target.value)}
              required
            />
          </div>
          <div className="mb-3">
            <label>Subclub URL (optional)</label>
            <input
              type="text"
              className="form-control"
              value={subClubUrl}
              onChange={(e) => setSubClubUrl(e.target.value)}
            />
          </div>
          <Button type="submit">Add</Button>
        </form>
      </Modal.Body>
    </Modal>
  );
}

const EditExplore = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const locationInputRef = useRef(null);
  const autocompleteRef = useRef(null);
  const [mapsLoaded, setMapsLoaded] = useState(false);

  // Form state
  const [formData, setFormData] = useState({
    trip_name: "",
    location: "",
    category: "",
    description: "",
    price: "",

    thumbnail: null,
    thumbnailUrl: "",
  });
  console.log("formData", formData);

  // Dynamic fields state
  // const [clubs, setClubs] = useState([
  //     { id: Date.now(), name: "", subClubs: [] },
  // ]);
  const [stay, setStay] = useState([{ id: Date.now(), description: "" }]);
  const [activities, setActivities] = useState([
    { id: Date.now(), description: "" },
  ]);
  const [exploreImages, setExploreImages] = useState([
    { id: Date.now(), file: null },
  ]);
  // const [socialLinks, setSocialLinks] = useState([
  //     { id: Date.now(), link: "", image: null, imageUrl: "" },
  // ]);
  // const [existingImages, setExistingImages] = useState([]);
  const [loading, setLoading] = useState(true);

  const options = [
    { value: "Facebook", label: "Facebook", icon: Facebook },
    { value: "Youtube", label: "Youtube", icon: Youtube },
    { value: "Tiktok", label: "Tiktok", icon: Tiktok },
    { value: "Instagram", label: "Instagram", icon: Instagram },
    { value: "Twitter", label: "Twitter", icon: Twitter },
  ];

  const [selectedOptions, setSelectedOptions] = useState([]);
  const [socialLinks, setSocialLinks] = useState({});

  const handleSelectChange = (selected) => {
    setSelectedOptions(selected || []);

    const updatedLinks = { ...socialLinks };
    selected.forEach((option) => {
      if (!updatedLinks[option.value]) {
        updatedLinks[option.value] = "";
      }
    });

    Object.keys(updatedLinks).forEach((key) => {
      if (!selected.some((option) => option.value === key)) {
        delete updatedLinks[key];
      }
    });

    setSocialLinks(updatedLinks);
  };

  const handleInputChange = (platform, value) => {
    setSocialLinks({
      ...socialLinks,
      [platform]: value,
    });
  };

  useEffect(() => {
    let checkInterval;
    let script;

    const initAutocomplete = async () => {
      try {
        // Double-check the input element exists
        if (!locationInputRef.current) {
          console.error("Location input element not found - retrying");
          setTimeout(initAutocomplete, 100);
          return;
        }

        if (!window.google?.maps?.importLibrary) {
          throw new Error("Google Maps API not loaded");
        }

        // Load required libraries
        const { Autocomplete } = await window.google.maps.importLibrary(
          "places"
        );

        // Create the autocomplete instance
        const autocomplete = new Autocomplete(locationInputRef.current, {
          types: ["geocode"], // restrict to geographical locations
          fields: ["formatted_address", "name", "geometry"], // specify the data to return
        });

        autocompleteRef.current = autocomplete;

        // Listen for place changes
        autocomplete.addListener("place_changed", () => {
          const place = autocomplete.getPlace();
          if (place) {
            setFormData((prev) => ({
              ...prev,
              location: place.formatted_address || place.name || "",
            }));
          }
        });

        setMapsLoaded(true);
      } catch (error) {
        console.error("Autocomplete initialization error:", error);
        setMapsLoaded(false);
      }
    };
    const loadGoogleMapsScript = () => {
      if (window.google?.maps) {
        initAutocomplete();
        return;
      }

      const script = document.createElement("script");
      script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyByJ2CSvo4VhY0WBeFZHf486JeHgYEBPbA&libraries=places&callback=initMap`;
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);
    };
    // Start the process after a small delay to ensure DOM is ready
    const initTimeout = setTimeout(() => {
      if (window.google?.maps?.importLibrary) {
        initAutocomplete();
      } else {
        loadGoogleMapsScript();
      }
    }, 100);

    return () => {
      clearTimeout(initTimeout);
      if (checkInterval) clearInterval(checkInterval);
      if (script) script.onload = script.onerror = null;
    };
  }, []);

  // Fetch existing data
  useEffect(() => {
    // Update your fetchExploreData function:
    const fetchExploreData = async () => {
      try {
        const response = await axios.get(`${REACT_APP_API_URL}/explore/${id}`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("user")}`,
          },
        });
        const data = response.data.data;
        console.log("data", data);
        // Basic form data
        setFormData({
          trip_name: data.trip_name,
          location: data.location,
          category: data.category,
          description: data.description,
          price: data.price,
          thumbnailUrl: data.thumbnail,
        });

        // Clubs and subclubs
        console.log("Fetched clubs from API:", data.clubs);

        if (data.clubs) {
          const parsedClubs = data.clubs.map((club) => ({
            name: club.name || "",
            url: club.url || "",
            subClubs: (club.subclubs || []).map((sc) => ({
              description: sc.description || "",
              url: sc.url || "",
            })),
          }));
          setClubs(parsedClubs);
        }

        //   setClubs(clubsArr);
        //   setSubClubs(subClubsObj);
        // }

        // Stays
        if (data.stays) {
          setStay(
            data.stays.map((s) => ({
              id: s.id || Date.now(),
              description: s.description,
            }))
          );
        }

        // Activities
        if (data.activities) {
          setActivities(
            data.activities.map((a) => ({
              id: a.id || Date.now(),
              description: a.description,
            }))
          );
        }

        // Social Links
        // In your fetchExploreData function, update the social links handling:
        if (data.socialLinks) {
          const linksObj = {};
          const selectedOpts = [];

          data.socialLinks.forEach((sl) => {
            // Extract platform name from the URL
            const platformMatch = sl.link.match(/https?:\/\/(www\.)?([^\/]+)/);
            if (platformMatch) {
              const domain = platformMatch[2].toLowerCase();
              let platform = "";

              // Map domain to platform
              if (domain.includes("facebook")) platform = "Facebook";
              else if (domain.includes("tiktok")) platform = "Tiktok";
              else if (domain.includes("twitter")) platform = "Twitter";
              else if (domain.includes("instagram")) platform = "Instagram";
              else if (domain.includes("youtube")) platform = "Youtube";

              if (platform) {
                linksObj[platform] = sl.link;
                const option = options.find((opt) => opt.value === platform);
                if (option) selectedOpts.push(option);
              }
            }
          });

          setSocialLinks(linksObj);
          setSelectedOptions(selectedOpts);
        }

        // Images
        if (data.images) {
          setExistingImages(data.images.map((img) => img));
        }

        setLoading(false);
      } catch (error) {
        console.error("Error fetching explore data:", error);
        setLoading(false);
      }
    };

    if (id) {
      fetchExploreData();
    } else {
      setLoading(false);
    }
  }, [id]);

  const [modalShow, setModalShow] = useState(false);
  const [subClubModalShow, setSubClubModalShow] = useState(false);
  const [selectedClubForSub, setSelectedClubForSub] = useState("");
  const [clubs, setClubs] = useState([]);
  const [clubModalShow, setClubModalShow] = useState(false);
  // const [subClubModalShow, setSubClubModalShow] = useState(false);
  const [selectedClubIndex, setSelectedClubIndex] = useState(null);

  const addClub = () => {
    setClubs([...clubs, { name: "", url: "", subClubs: [] }]);
  };

  const handleAddClub = (club) => {
    setClubs([...clubs, club]);
  };

  // const handleAddSubClub = (clubIndex, subclub) => {
  //   const updated = [...clubs];
  //   updated[clubIndex].subClubs.push(subclub);
  //   setClubs(updated);
  // };

  const handleAddSubClub = (clubIndex, subclub) => {
    const updatedClubs = [...clubs];
    const updatedClub = {
      ...updatedClubs[clubIndex],
      subClubs: [...(updatedClubs[clubIndex].subClubs || []), subclub],
    };

    updatedClubs[clubIndex] = updatedClub;
    setClubs(updatedClubs);
  };

  const removeClub = (index) => {
    setClubs(clubs.filter((_, idx) => idx !== index));
  };

  const addSubClub = (clubIndex) => {
    const updated = [...clubs];
    updated[clubIndex].subClubs.push({ description: "", url: "" });
    setClubs(updated);
  };

  const removeSubClub = (clubIndex, subIndex) => {
    const updated = [...clubs];
    updated[clubIndex].subClubs = updated[clubIndex].subClubs.filter(
      (_, i) => i !== subIndex
    );
    setClubs(updated);
  };

  const addStay = () => {
    setStay([...stay, { id: Date.now(), description: "" }]);
  };

  const removeStay = (id) => {
    setStay(stay.filter((s) => s.id !== id));
  };

  const updateStay = (id, value) => {
    setStay(stay.map((s) => (s.id === id ? { ...s, description: value } : s)));
  };

  const addActivity = () => {
    setActivities([...activities, { id: Date.now(), description: "" }]);
  };

  const removeActivity = (id) => {
    setActivities(activities.filter((a) => a.id !== id));
  };

  const updateActivity = (id, value) => {
    setActivities(
      activities.map((a) => (a.id === id ? { ...a, description: value } : a))
    );
  };

  const addExploreImage = () => {
    setExploreImages([...exploreImages, { id: Date.now(), file: null }]);
  };

  const removeExploreImage = (id) => {
    setExploreImages(exploreImages.filter((img) => img.id !== id));
  };

  const updateExploreImage = (id, file) => {
    setExploreImages(
      exploreImages.map((img) => (img.id === id ? { ...img, file } : img))
    );
  };

  // const removeExistingImage = (imageUrl) => {
  //     setExistingImages(existingImages.filter((img) => img !== imageUrl));
  // };

  const [selectedPrice, setSelectedPrice] = useState(null); // To track selected price

  const handleSelect = (price) => {
    setSelectedPrice(price);
    console.log(price);
    setFormData({ ...formData, price: price });
  };

  const [images, setImages] = useState([]); // Frontend-uploaded images
  const [existingImages, setExistingImages] = useState([]); // Backend images

  const onDrop = useCallback(
    (acceptedFiles) => {
      if (images.length + acceptedFiles.length + existingImages.length <= 6) {
        const newImages = acceptedFiles.map((file) =>
          Object.assign(file, {
            preview: URL.createObjectURL(file), // Create image preview URL for new files
          })
        );
        setImages((prevImages) => [...prevImages, ...newImages]);
      } else {
        alert("You can only upload a maximum of 6 images.");
      }
    },
    [images, existingImages]
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: "image/*", // Only allow image uploads
    maxFiles: 6,
    maxSize: 2097152, // 2MB per file (optional)
  });

  // Function to remove frontend-uploaded images
  const removeImage = (fileToRemove) => {
    setImages(images.filter((file) => file !== fileToRemove));
  };

  // Function to remove backend images
  const removeExistingImage = (imageToRemove) => {
    // Implement backend functionality to remove the image here, e.g., API call
    // Example: call API to remove the image by its ID
    // Once removed, update the state to remove it from the preview
    setExistingImages(
      existingImages.filter((image) => image !== imageToRemove)
    );
  };

  // Form submission

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const formDataToSend = new FormData();

      // Append basic fields
      formDataToSend.append("trip_name", formData.trip_name);
      formDataToSend.append("location", formData.location);
      formDataToSend.append("category", formData.category);
      formDataToSend.append("description", formData.description);
      formDataToSend.append("price", formData.price); // Use formData.price

      // Append thumbnail if changed
      if (formData.thumbnail) {
        formDataToSend.append("thumbnail", formData.thumbnail);
      }

      // Prepare clubs data with subclubs
      const clubsData = clubs.map((club) => ({
        name: club.name,
        url: club.url,
        subClubs: club.subClubs.map((sc) => ({
          description: sc.description,
          url: sc.url,
        })),
      }));
      formDataToSend.append("clubs", JSON.stringify(clubsData));

      // Append stay data
      formDataToSend.append(
        "stays",
        JSON.stringify(stay.map((s) => ({ description: s.description })))
      );

      // Append activities data
      formDataToSend.append(
        "activities",
        JSON.stringify(activities.map((a) => ({ description: a.description })))
      );

      // Prepare social links data
      const socialLinksData = selectedOptions.map((option) => ({
        title: option.value,
        link: socialLinks[option.value] || "",
      }));
      formDataToSend.append("socialLinks", JSON.stringify(socialLinksData));

      // Append explore images
      images.forEach((img) => {
        formDataToSend.append("explore", img);
      });

      // Append existing images that weren't deleted
      formDataToSend.append(
        "existingImages",
        JSON.stringify(
          existingImages.map((img) => {
            // Extract just the filename from the URL
            const parts = img.split("/");
            return parts[parts.length - 1];
          })
        )
      );

      const response = await axios.post(
        `${REACT_APP_API_URL}/update-Explore/${id}`,
        formDataToSend,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${localStorage.getItem("user")}`,
          },
        }
      );
      console.log("response", response.data.data);
      if (response.data.code === 200) {
        showToast("success", "Explore updated successfully");
        navigate(`/explore/detail/${response.data.data.id}`);
      }
    } catch (error) {
      console.error("Error saving explore:", error);
      showToast("error", "Failed to save explore. Please try again.");
    }
  };

  if (loading) {
    return <Layout>Loading...</Layout>;
  }

  return (
    <Layout>
      <div className="row">
        <div className="col-12">
          <Link to={`/explore/detail/${id}`} className="btn btn-primary px-5">
            Back
          </Link>
          <div className="card mt-4">
            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-12">
                    <label htmlFor="thumbnail" className="form-label fs-6">
                      Upload Thumbnail
                    </label>
                    <div className="d-flex align-items-start flex-column gap-1 mb-3">
                      <Inputbox
                        type="file"
                        accept={"image/*"}
                        className="form-control"
                        id="thumbnail"
                        name="thumbnail"
                        onChange={(e) => {
                          const file = e.target.files[0];
                          if (file) {
                            const previewUrl = URL.createObjectURL(file);
                            setFormData({
                              ...formData,
                              thumbnail: file,
                              thumbnailUrl: previewUrl,
                            });
                          }
                        }}
                      />

                      {(formData.thumbnailUrl || formData.thumbnail) && (
                        <img
                          src={formData.thumbnailUrl}
                          alt="Current thumbnail"
                          style={{
                            width: "100px",
                            height: "100px",
                            objectFit: "cover",
                            borderRadius: "5px",
                          }}
                        />
                      )}
                    </div>
                  </div>

                  <div className="col-12 mt-4">
                    <label htmlFor="stays" className="form-label fs-6">
                      Upload Images
                    </label>

                    {/* Dropzone for uploading images */}
                    <div {...getRootProps()} className="dropzone-box">
                      <input {...getInputProps()} />
                      {isDragActive ? (
                        <p>Drop the files here ...</p>
                      ) : (
                        <p className="m-0 text-center">
                          <BiSolidCloudUpload className="fs-1" />
                          <br /> Upload Image
                        </p>
                      )}
                    </div>

                    {/* Display existing images from the backend */}
                    <div className="image-preview-container d-flex gap-2 mt-2 align-items-center">
                      {existingImages.map((image, index) => (
                        <div className="position-relative" key={index}>
                          <img
                            src={image} // Use the image URL from the backend
                            alt={`existing ${index}`}
                            style={{
                              width: "100px",
                              height: "100px",
                              objectFit: "cover",
                              borderRadius: "5px",
                            }}
                          />
                          <a
                            href="#"
                            className="position-absolute top-0 end-0 bg-danger text-white p-1 rounded"
                            style={{ transform: "translate(30%, -30%)" }}
                            onClick={(e) => {
                              e.preventDefault();
                              removeExistingImage(image); // Remove the backend image
                            }}
                          >
                            <BiTrash />
                          </a>
                        </div>
                      ))}

                      {images.map((file, index) => (
                        <div className="position-relative" key={index}>
                          <img
                            src={file.preview} // Use the preview URL for newly uploaded images
                            alt={`preview ${index}`}
                            style={{
                              width: "100px",
                              height: "100px",
                              objectFit: "cover",
                              borderRadius: "5px",
                            }}
                          />
                          <a
                            href="#"
                            className="position-absolute top-0 end-0 bg-danger text-white p-1 rounded"
                            style={{ transform: "translate(30%, -30%)" }}
                            onClick={(e) => {
                              e.preventDefault();
                              removeImage(file); // Remove the uploaded image
                            }}
                          >
                            <BiTrash />
                          </a>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="col-12 mt-4">
                    <label htmlFor="tripname" className="form-label fs-6">
                      Trip Name
                    </label>
                    <Inputbox
                      type="text"
                      placeholder="Enter trip name"
                      className="form-control"
                      id="tripname"
                      name="tripname"
                      value={formData.trip_name}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          trip_name: e.target.value,
                        })
                      }
                    />
                  </div>

                  <div className="col-12 mt-4">
                    <label htmlFor="triplocation" className="form-label fs-6">
                      Location
                    </label>

                    <input
                      type="text"
                      placeholder="Enter location"
                      className="form-control"
                      id="triplocation"
                      name="triplocation"
                      ref={locationInputRef}
                      value={formData.location}
                      onChange={(e) => {
                        setFormData({
                          ...formData,
                          location: e.target.value,
                        });
                      }}
                      autoComplete="off" // Important to prevent browser autocomplete
                    />
                  </div>

                  <div className="col-12 mt-4 position-relative">
                    <label htmlFor="tripcategory" className="form-label fs-6">
                      Category
                    </label>
                    <select
                      name="tripcategory"
                      id="tripcategory"
                      className="form-control"
                      value={formData.category}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          category: e.target.value,
                        })
                      }
                      required
                    >
                      <option value="" disabled hidden>
                        Select category
                      </option>
                      <option value="city">City</option>
                      <option value="resort">Resort</option>
                    </select>
                    <BiChevronDown
                      className="position-absolute fs-4"
                      style={{ right: 26, top: 35 }}
                    />
                  </div>

                  <div className="col-12 mt-4">
                    <div className="position-relative course-field">
                      <label htmlFor="tripCourse" className="form-label fs-6">
                        Clubs
                      </label>
                      <div className="position-relative main-clubs ">
                        {clubs.map((club, clubIndex) => (
                          <div key={clubIndex} className="mb-3 ">
                            <div className="position-relative">
                              <input
                                type="text"
                                className="form-control mb-2"
                                placeholder="Club Name"
                                value={club.name}
                                onChange={(e) => {
                                  const updated = [...clubs];
                                  updated[clubIndex].name = e.target.value;
                                  setClubs(updated);
                                }}
                              />
                              <a
                                href="#"
                                className="position-absolute end-0 top-0 remove-event"
                                onClick={() => removeClub(clubIndex)}
                              >
                                <BiMinus className="bx" />
                              </a>
                            </div>
                            <input
                              type="text"
                              className="form-control mb-2"
                              placeholder="Club URL"
                              value={club.url}
                              onChange={(e) => {
                                const updated = [...clubs];
                                updated[clubIndex].url = e.target.value;
                                setClubs(updated);
                              }}
                            />

                            {/* Subclubs */}
                            {club.subClubs?.map((sub, subIndex) => (
                              <div
                                key={subIndex}
                                className="d-flex gap-2 mb-2 align-items-center"
                              >
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Subclub Description"
                                  value={sub.description}
                                  onChange={(e) => {
                                    const updated = [...clubs];
                                    updated[clubIndex].subClubs[
                                      subIndex
                                    ].description = e.target.value;
                                    setClubs(updated);
                                  }}
                                />
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Subclub URL"
                                  value={sub.url}
                                  onChange={(e) => {
                                    const updated = [...clubs];
                                    updated[clubIndex].subClubs[subIndex].url =
                                      e.target.value;
                                    setClubs(updated);
                                  }}
                                />
                                <button
                                  style={{ height: 44, paddingInline: 14 }}
                                  className="btn btn-primary"
                                  type="button"
                                  onClick={() =>
                                    removeSubClub(clubIndex, subIndex)
                                  }
                                >
                                  <BiMinus />
                                </button>
                              </div>
                            ))}

                            {/* Add Subclub Button */}
                            <button
                              type="button"
                              className="btn btn-sm btn-outline-primary me-2 mt-1"
                              onClick={() => {
                                setSelectedClubIndex(clubIndex);
                                setSubClubModalShow(true); // open modal to add subclub
                              }}
                            >
                              <BiPlus className="bx" /> Add Subclub
                            </button>

                            {/* Remove Club */}
                          </div>
                        ))}
                      </div>

                      {/* Add Club Modal Trigger */}
                      <p
                        className="position-absolute top-0 end-0 add-club"
                        style={{
                          right: "10px",
                          top: "5px",
                          color: "#264a2e",
                          cursor: "pointer",
                        }}
                        onClick={() => setClubModalShow(true)} // use a separate modal for clubs
                      >
                        <BiPlus className="bx" /> Add Club
                      </p>
                    </div>
                  </div>

                  {/* Stays Section */}
                  {formData.category === "City" && (
                    <div className="col-12 mt-4">
                      <div className="position-relative course-field">
                        <label htmlFor="stays" className="form-label fs-6">
                          Stays
                        </label>
                        {stay.map((s, index) => (
                          <div key={s.id} className="mb-2 position-relative">
                            <Inputbox
                              type="text"
                              placeholder="Enter stay"
                              className="form-control"
                              value={s.description}
                              onChange={(e) => updateStay(s.id, e.target.value)}
                            />
                            <p
                              className="position-absolute m-0 top-0 end-0 remove-course"
                              style={{
                                right: "10px",
                                top: "5px",
                                cursor: "pointer",
                              }}
                              onClick={(e) => {
                                e.preventDefault();
                                removeStay(s.id);
                              }}
                            >
                              <BiMinus className="bx" />
                            </p>
                          </div>
                        ))}
                        <p
                          className="position-absolute top-0 end-0 add-course m-0"
                          style={{
                            right: "10px",
                            top: "5px",
                            cursor: "pointer",
                            color: "#264A2E",
                          }}
                          onClick={addStay}
                        >
                          <BiPlus className="bx" /> Add
                        </p>
                      </div>
                    </div>
                  )}
                  <div className="col-12 mt-4">
                    <div className="position-relative course-field">
                      <label htmlFor="activities" className="form-label fs-6">
                        Additional Activities
                      </label>
                      {activities.map((activity, index) => (
                        <div
                          key={activity.id}
                          className="mb-2 position-relative"
                        >
                          <Inputbox
                            type="text"
                            placeholder="Enter activity"
                            className="form-control"
                            value={activity.description}
                            onChange={(e) =>
                              updateActivity(activity.id, e.target.value)
                            }
                          />
                          <p
                            className="position-absolute top-0 end-0 remove-course m-0"
                            style={{
                              right: "10px",
                              top: "5px",
                              cursor: "pointer",
                            }}
                            onClick={(e) => {
                              e.preventDefault();
                              removeActivity(activity.id);
                            }}
                          >
                            <BiMinus className="bx" />
                          </p>
                        </div>
                      ))}
                      <p
                        className="position-absolute top-0 end-0 add-course m-0"
                        style={{
                          right: "10px",
                          top: "5px",
                          cursor: "pointer",
                          color: "#264A2E",
                        }}
                        onClick={addActivity}
                      >
                        <BiPlus className="bx" /> Add
                      </p>
                    </div>
                  </div>

                  <div className="col-12 mt-4">
                    <label htmlFor="description" className="form-label fs-6">
                      Description
                    </label>
                    <textarea
                      name="description"
                      className="form-control"
                      style={{ resize: "none" }}
                      placeholder="Enter description"
                      rows="6"
                      id="description"
                      value={formData.description}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          description: e.target.value,
                        })
                      }
                    ></textarea>
                  </div>

                  {/* <div className="col-12 mt-4">
                                        <label htmlFor="price" className="form-label fs-6">
                                            Price
                                        </label>
                                        <Inputbox
                                            type="number"
                                            placeholder="Enter price"
                                            className="form-control"
                                            id="price"
                                            name="price"
                                            value={formData.price}
                                            onChange={(e) =>
                                                setFormData({
                                                    ...formData,
                                                    price: e.target.value,
                                                })
                                            }
                                        />
                                    </div> */}

                  <div className="col-12 mt-4">
                    <label htmlFor="Price" className="form-label fs-6">
                      Price
                    </label>
                    <div className="mt-2 d-flex gap-3">
                      <p
                        className={`price-select m-0 ${
                          formData.price == "1" ? "selected" : ""
                        }`}
                        onClick={() => handleSelect("1")}
                      >
                        {" "}
                        $
                      </p>
                      <p
                        className={`price-select m-0 ${
                          formData.price == "2" ? "selected" : ""
                        }`}
                        onClick={() => handleSelect("2")}
                      >
                        {" "}
                        $$
                      </p>
                      <p
                        className={`price-select m-0 ${
                          formData.price == "3" ? "selected" : ""
                        }`}
                        onClick={() => handleSelect("3")}
                      >
                        {" "}
                        $$$
                      </p>
                    </div>
                  </div>

                  <div className="col-12 mt-4">
                    <div className="position-relative course-field">
                      <label htmlFor="stays" className="form-label fs-6">
                        Social Links
                      </label>
                      <Select
                        isMulti
                        name="socialLinks"
                        options={options}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        onChange={handleSelectChange}
                        value={selectedOptions} // Make sure to set the current value
                      />
                      {selectedOptions.length > 0 && (
                        <div className="mt-3">
                          {selectedOptions.map((option) => (
                            <div
                              key={option.value}
                              className="input-group mb-3"
                            >
                              <span className="input-group-text">
                                <img
                                  src={option.icon}
                                  height={25}
                                  alt={option.label}
                                />
                              </span>
                              <input
                                type="text"
                                className="form-control"
                                placeholder={`Enter ${option.label} link`}
                                value={socialLinks[option.value] || ""}
                                onChange={(e) =>
                                  handleInputChange(
                                    option.value,
                                    e.target.value
                                  )
                                }
                              />
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12">
                      <Button type="submit" className="px-5 mt-4">
                        {id ? "Update" : "Create"}
                      </Button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <MyVerticallyCenteredModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        onAddClub={addClub}
      />

      <AddClubModal
        show={clubModalShow}
        onHide={() => setClubModalShow(false)}
        onAddClub={handleAddClub}
      />

      <AddSubClubModal
        show={subClubModalShow}
        onHide={() => setSubClubModalShow(false)}
        onAddSubClub={handleAddSubClub}
        mainClubIndex={selectedClubIndex} // rename this
      />
    </Layout>
  );
};

export default EditExplore;
